<template>
  <div
    class="min-height dashboard-screen-container inputcontainer theme--light"
  >
    <CRow>
      <CCol sm="6" class="d-align">
        <h3 class="m-0">User Data</h3>
      </CCol>
      <CCol sm="6">
        <CRow>
          <CCol sm="6" class="form-group search-div">
            <label for>Search by city</label>
            <div class="col-sm-12 p-0 search-div">
              <input
                type="text"
                class="form-control"
                placeholder="Search"
                v-model="search"
              />
              <!-- <div class="search-svg">
                <searchSVG />
              </div>-->
              <div
                v-if="search !== ''"
                class="search-svg position-absolute"
                @click="clearSearch()"
              >
                <crossSVG />
              </div>
              <!-- <div class="search-svg">
              <crossSVG />
              </div>-->
            </div>
          </CCol>
          <CCol sm="6" class="datepicker pos-r">
            <label for>Date Range</label>
            <datepicker
              v-model="dateRange"
              @input="dateChange()"
              ref="datepicker"
              :model-config="datePickerConfig"
              :max-date="new Date()"
              is-range
              :masks="{ input: 'DD-MM-YYYY' }"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <input
                  :value="
                    !!inputValue.start && !!inputValue.end
                      ? inputValue.start + ' - ' + inputValue.end
                      : 'DD/MM/YYYY'
                  "
                  v-on="inputEvents.start"
                  class="form-control position-relative"
                  placeholder="DD-MM-YYYY"
                />

                <div
                  v-if="!!inputValue.start && !!inputValue.end"
                  class="cross-svg"
                  @click="resetDate"
                >
                  <crossSVG />
                </div>
              </template>
            </datepicker>
            <div class="calendarsvg pos-svg pos-a">
              <calendarSVG />
            </div>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
    <!-- ........................................................... -->
    <CRow>
      <CCol sm="12">
        <v-tabs
          v-model="tabs"
          background-color="transparent"
          class="border-bottom border-top"
        >
          <v-tab v-for="(item, i) in items" :key="i">{{ item.tabName }}</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabs">
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <CRow>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Total Patients</h5>
                          <small>(Registered with DocSmart)</small>
                          <h5 class="text-success mb-0">
                            {{
                              patientDetails ? patientDetails.total_patients : 0
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Active Patients</h5>
                          <small>(Active within last 60 days)</small>
                          <h5 class="text-success mb-0">
                            {{
                              patientDetails
                                ? patientDetails.active_patients
                                : 0
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Total Bookings</h5>
                          <h5 class="text-success mb-0">
                            {{ total_bookings }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Average bookings</h5>
                          <h5 class="text-success mb-0">
                            {{
                              patientDetails && patientDetails.total_patients > 0
                                ? (
                                    total_bookings /
                                    patientDetails.total_patients
                                  ).toFixed(2)
                                : 0
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                </CRow>
                <!-- ............ -->
                <CRow>
                  <CCol sm="12" class="pb-0">
                    <h5>Break up of bookings</h5>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol sm="6" md="4">
                    <div class="value-card">
                      <div class="d-flex mb-2">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Appointments</h5>
                          <h5 class="text-success mb-0">
                            {{
                              patientDetails
                                ? patientDetails.clinic_appointment_details.total_appointments
                                : 0
                            }}
                          </h5>
                        </div>
                      </div>
                      <hr class="hr-line" />
                      <div class="d-just-space mb-3">
                        <div>
                          <h6 class="mb-0">Pending</h6>
                        </div>
                        <div>
                          <h6>
                            {{
                              patientDetails
                                ? (patientDetails.clinic_appointment_details.pending_appointments + patientDetails.clinic_appointment_details.upcoming_appointments) 
                                : 0
                            }}
                          </h6>
                        </div>
                      </div>
                      <div class="d-just-space mb-3">
                        <div>
                          <h6 class="mb-0">Completed</h6>
                        </div>
                        <div>
                          <h6>
                            {{
                              patientDetails
                                ? patientDetails.clinic_appointment_details.completed_appointments
                                : 0
                            }}
                          </h6>
                        </div>
                      </div>
                      <div class="d-just-space">
                        <div>
                          <h6 class="mb-0">Cancelled</h6>
                        </div>
                        <div>
                          <h6>
                            {{
                              patientDetails
                                ? patientDetails.clinic_appointment_details.cancelled_appointments
                                : 0
                            }}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="4">
                    <div class="value-card">
                      <div class="d-flex mb-2">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Home Visit</h5>
                          <h5 class="text-success mb-0">
                            {{
                              patientDetails
                                ? patientDetails.home_visit_details.total_appointments
                                : 0
                            }}
                          </h5>
                        </div>
                      </div>
                      <hr class="hr-line" />
                      <div class="d-just-space mb-3">
                        <div>
                          <h6 class="mb-0">Pending</h6>
                        </div>
                        <div>
                          <h6>
                            {{
                              patientDetails
                                ? (patientDetails.home_visit_details.upcoming_appointments + patientDetails.home_visit_details.pending_appointments)
                                : 0
                            }}
                          </h6>
                        </div>
                      </div>
                      <div class="d-just-space mb-3">
                        <div>
                          <h6 class="mb-0">Completed</h6>
                        </div>
                        <div>
                          <h6>
                            {{
                              patientDetails
                                ? patientDetails.home_visit_details.completed_appointments
                                : 0
                            }}
                          </h6>
                        </div>
                      </div>
                      <div class="d-just-space">
                        <div>
                          <h6 class="mb-0">Cancelled</h6>
                        </div>
                        <div>
                          <h6>
                            {{
                              patientDetails
                                ? patientDetails.home_visit_details.cancelled_appointments
                                : 0
                            }}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="4">
                    <div class="value-card">
                      <div class="d-flex mb-2">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Online Consultation</h5>
                          <h5 class="text-success mb-0">
                            {{
                              patientDetails
                                ? patientDetails.online_consultancy_details.total
                                : 0
                            }}
                          </h5>
                        </div>
                      </div>
                      <hr class="hr-line" />
                      <div class="d-just-space mb-3">
                        <div>
                          <h6 class="mb-0">Pending</h6>
                        </div>
                        <div>
                          <h6>
                            {{
                              patientDetails
                                ? patientDetails.online_consultancy_details.pending
                                : 0
                            }}
                          </h6>
                        </div>
                      </div>
                      <div class="d-just-space mb-3">
                        <div>
                          <h6 class="mb-0">Ongoing</h6>
                        </div>
                        <div>
                          <h6>
                            {{
                              patientDetails
                                ? patientDetails.online_consultancy_details.ongoing
                                : 0
                            }}
                          </h6>
                        </div>
                      </div>
                      <div class="d-just-space mb-3">
                        <div>
                          <h6 class="mb-0">Completed</h6>
                        </div>
                        <div>
                          <h6>
                            {{
                              patientDetails
                                ? patientDetails.online_consultancy_details.completed
                                : 0
                            }}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </CCol>
                </CRow>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- ............................. patient .............................. -->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <CRow>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Total Doctors</h5>
                          <small>(Registered with DocSmart)</small>
                          <h5 class="text-success mb-0">
                            {{
                              doctorDetails ? doctorDetails.total_doctors : 0
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Active Doctors</h5>
                          <small>(Active within last 30 days)</small>
                          <h5 class="text-success mb-0">
                            {{
                              doctorDetails ? doctorDetails.active_doctors : 0
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Total Bookings</h5>
                          <h5 class="text-success mb-0">
                            {{ doctorDetails ? doctorDetails.total_bookings : 0 }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Average bookings</h5>
                          <h5 class="text-success mb-0">
                            {{
                              doctorDetails ? doctorDetails.avg_bookings : 0
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Total Completed Bookings</h5>
                          <h5 class="text-success mb-0">
                            {{
                              doctorDetails
                                ? doctorDetails.total_completed_bookings
                                : 0
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                </CRow>
                <!-- ............ -->
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- ............................. doctors .............................. -->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <CRow>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Total Pharmacy Centres</h5>
                          <small>(Registered with DocSmart)</small>
                          <h5 class="text-success mb-0">
                            {{
                              pharmacyAccount.totalCentersCount
                                ? pharmacyAccount.totalCentersCount
                                : 0
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Active Centres</h5>
                          <small>(Active within last 30 days)</small>
                          <h5 class="text-success mb-0">
                            {{
                              pharmacyAccount.activeCenterCount
                                ? pharmacyAccount.activeCenterCount
                                : 0
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Total Bookings</h5>
                          <h5 class="text-success mb-0">
                            {{
                              pharmacyAccount.totalBooking
                                ? pharmacyAccount.totalBooking
                                : 0
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Completed bookings</h5>
                          <h5 class="text-success mb-0">
                            {{
                              pharmacyAccount.totalCompletedBooking
                                ? pharmacyAccount.totalCompletedBooking
                                : 0
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Average bookings</h5>
                          <h5 class="text-success mb-0">
                            {{
                              pharmacyAccount.averageBooking
                                ? pharmacyAccount.averageBooking
                                : 0
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                </CRow>
                <!-- ............ -->
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- ............................. Pharmacy .............................. -->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <CRow>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Total Diagnostic Centres</h5>
                          <small>(Registered with DocSmart)</small>
                          <h5 class="text-success mb-0">
                            {{
                              diagnosticAccount.totalCentersCount
                                ? diagnosticAccount.totalCentersCount
                                : 0
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Active Centres</h5>
                          <small>(Active within last 30 days)</small>
                          <h5 class="text-success mb-0">
                            {{
                              diagnosticAccount.activeCenterCount
                                ? diagnosticAccount.activeCenterCount
                                : 0
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Total Bookings</h5>
                          <h5 class="text-success mb-0">
                            {{
                              diagnosticAccount.totalBooking
                                ? diagnosticAccount.totalBooking
                                : 0
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Completed bookings</h5>
                          <h5 class="text-success mb-0">
                            {{
                              diagnosticAccount.totalCompletedBooking
                                ? diagnosticAccount.totalCompletedBooking
                                : 0
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Average bookings</h5>
                          <h5 class="text-success mb-0">
                            {{
                              diagnosticAccount.averageBooking
                                ? diagnosticAccount.averageBooking
                                : 0
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                </CRow>
                <!-- ............ -->
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- ............................. diagnostic .............................. -->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <CRow>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Total Ambulance Centres</h5>
                          <small>(Registered with DocSmart)</small>
                          <h5 class="text-success mb-0">
                            {{
                              ambulanceAccount &&
                              ambulanceAccount.totalAmbulanceAddress
                                ? ambulanceAccount.totalAmbulanceAddress
                                : 0
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Active Centres</h5>
                          <small>
                            (Ambulance centre who used the app in last 30 days)
                          </small>
                          <h5 class="text-success mb-0">
                            {{
                              ambulanceAccount &&
                              ambulanceAccount.totalActiveCenters
                                ? ambulanceAccount.totalActiveCenters
                                : 0
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Total Bookings</h5>
                          <h5 class="text-success mb-0">
                            {{
                              ambulanceAccount && ambulanceAccount.totalBooking
                                ? ambulanceAccount.totalBooking
                                : 0
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Completed bookings</h5>
                          <h5 class="text-success mb-0">
                            {{
                              ambulanceAccount &&
                              ambulanceAccount.totalCompletedBooking
                                ? ambulanceAccount.totalCompletedBooking
                                : 0
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Average bookings</h5>
                          <h5 class="text-success mb-0">
                            {{
                              ambulanceAccount &&
                              ambulanceAccount.averageBooking
                                ? ambulanceAccount.averageBooking
                                : 0
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                </CRow>
                <!-- ............ -->
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- ............................. ambulance .............................. -->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <CRow>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Total Bloodbank Location</h5>
                          <small>(Registered with DocSmart)</small>
                          <h5 class="text-success mb-0">
                            {{
                              bloodbankDetails
                                ? bloodbankDetails.total_bloodbanks
                                : 0
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Active Centres</h5>
                          <small>
                            (Ambulance centre who used the app in last 30 days)
                          </small>
                          <h5 class="text-success mb-0">
                            {{
                              bloodbankDetails
                                ? bloodbankDetails.active_bloodbanks
                                : 0
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Total Bookings</h5>
                          <h5 class="text-success mb-0">
                            {{
                              bloodbankDetails
                                ? bloodbankDetails.total_bookings
                                : 0
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Average bookings</h5>
                          <h5 class="text-success mb-0">
                            {{
                              bloodbankDetails
                                ? bloodbankDetails.avg_bookings.toFixed(2)
                                : 0
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Completed bookings</h5>
                          <h5 class="text-success mb-0">
                            {{
                              bloodbankDetails
                                ? bloodbankDetails.total_completed_bookings
                                : 0
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                </CRow>
                <!-- ............ -->
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- ............................. bloodbank .............................. -->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <CRow>
                  <CCol sm="6" md="4">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Total Vendors</h5>
                          <h5 class="text-success mb-0">
                            {{ vendorDetails ? vendorDetails.vendors : 0 }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="4">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Total Items</h5>
                          <h5 class="text-success mb-0">
                            {{ vendorDetails ? vendorDetails.products : 0 }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="4">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Total Carts</h5>
                          <h5 class="text-success mb-0">
                            {{ vendorDetails ? vendorDetails.cartCount : 0 }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" class="lg-card">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Total Wish lists</h5>
                          <h5 class="text-success mb-0">
                            {{
                              vendorDetails ? vendorDetails.wishlistCount : 0
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" class="lg-card">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Total orders</h5>
                          <h5 class="text-success mb-0">
                            {{ vendorDetails ? vendorDetails.orders : 0 }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                </CRow>
                <!-- ............ -->
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- ............................. vendors  .............................. -->
        </v-tabs-items>
      </CCol>
    </CRow>
  </div>
</template>
<script>
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
import { pickSvg } from "@/views/SVG";
const Image = () => import("@/components/image.vue");
import config from "@/config.js";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .build();
export default {
  components: {
    Datepicker,
    ...pickSvg("crossSVG", "searchSVG"),
    "image-view": Image,
  },
  data() {
    return {
      search: "",
      datePickerConfig: {
        start: {
          timeAdjust: "00:00:00",
        },
        end: {
          timeAdjust: "23:59:59",
        },
      },
      dateRange: {
        start: "",
        end: "",
      },
      tabs: null,
      items: [
        { tabName: "Patient" },
        { tabName: "Doctors" },
        { tabName: "Pharmacy" },
        { tabName: "Diagnostics" },
        { tabName: "Ambulance" },
        { tabName: "Blood Bank" },
        { tabName: "Vendors" },
      ],
      diagnosticAccount: {},
      pharmacyAccount: {},
      ambulanceAccount: {},
      patientDetails: null,
      doctorDetails: null,
      vendorDetails: null,
      bloodbankDetails: null,
      dayJS,
    };
  },
  computed: {
    total_bookings() {
      return this.patientDetails ? 
        (this.patientDetails.home_visit_details.total_appointments +
        this.patientDetails.clinic_appointment_details.total_appointments +
        this.patientDetails.online_consultancy_details.total) :
        0;
    },
  },
  watch: {
    tabs: {
      handler(currentTab) {
        this.delegateSearch(currentTab, this.urlBuilder(this.items[currentTab].tabName));
      },
      deep: true,
    },
    search: {
      handler(_) {
        this.delegateSearch(this.tabs, this.urlBuilder(this.items[this.tabs].tabName));
      },
    },
  },
  methods: {
    delegateSearch(currentTab, urlBuilder) {
      switch (currentTab) {
        case 0:
          this.getPatientData(urlBuilder);
          break;
        case 1:
          this.getDoctorData(urlBuilder);
          break;
        case 2:
          this.getPharmacyData(urlBuilder);
          break;
        case 3:
          this.getDiagnosticData(urlBuilder);
          break;
        case 4:
          this.getAmbulanceData(urlBuilder);
          break;
        case 5:
          this.getBloodbankData(urlBuilder);
          break;
        case 6:
          this.getVendorData(urlBuilder);
          break;
      }
    },
    clearSearch() {
      this.search = "";
    },
    getDiagnosticData(urlBuilder) {
      this.$http.get(urlBuilder).then((response) => {
        if (response.body.status) {
          this.diagnosticAccount = response.body.data;
        }
      });
    },
    getPharmacyData(urlBuilder) {
      this.$http.get(urlBuilder).then((response) => {
        if (response.body.status) {
          this.pharmacyAccount = response.body.data;
        }
      });
    },
    getAmbulanceData(url = `${config.AMBULANCE_URL}api/v1/admin/over-all-account`) {
      this.$http.get(url).then((response) => {
        if (response.body.status) {
          this.ambulanceAccount = response.body.data;
        }
      });
    },
    getPatientData(url) {
      this.$http.get(url).then((response) => {
        if (response.body.status) {
          this.patientDetails = response.body.data;
        }
      });
    },
    getDoctorData(url) {
      this.$http.get(url).then((response) => {
        if (response.body.status) {
          this.doctorDetails = response.body.data;
        }
      });
    },
    getVendorData(url) {
      this.$http.get(url).then((response) => {
        if (response.body) {
          this.vendorDetails = response.body;
        }
      });
    },
    getBloodbankData(url) {
      this.$http.get(url).then((response) => {
        if (response.body.status) {
          this.bloodbankDetails = response.body.data;
        }
      });
    },
    urlBuilder(tabName) {
      let url = "";
      switch (tabName) {
        case "Patient":
          url = `${config.BASE_URL}api/v2/admin/patient/usage-data`;
          break;
        case "Doctors":
          url = `${config.BASE_URL}api/v2/admin/doctor/usage-data`;
          break;
        case "Pharmacy":
          url = `${config.PHARMACY_URL}api/v1/admin/over-all-account`;
          break;
        case "Diagnostics":
          url = `${config.DIAGNOSTICS_URL}api/v1/admin/over-all-account`;
          break;
        case "Ambulance":
          url = `${config.AMBULANCE_URL}api/v1/admin/over-all-account`;
          break;
        case "Blood Bank":
          url = `${config.BASE_URL}api/v2/admin/bloodbank/usage-data`;
          break;
        case "Vendors":
          url = `${config.VENDORS_URL}api/v1/admin/vendor/usage-data`;
          break;
      }
      if (this.search.length > 0) {
        url += `?city=${this.search}`;
      }
      return url;
    },
    dateChange() {
     let url 
      if (this.tabs == 3 || this.tabs == 2) {
       url = this.urlBuilder(this.items[this.tabs].tabName);
        url += `${
          url.indexOf("?") ? "?" : "&"
        }start_date=${
         this.dayJS(this.dateRange.start).format("YYYY-MM-DD") 
        }&end_date=${this.dayJS(this.dateRange.end).format("YYYY-MM-DD") }`;
      } else {
        url = this.urlBuilder(this.items[this.tabs].tabName);
        url += `${
          url.indexOf("?") ? "?" : "&"
        }date_range_applicable=true&start_date=${
          this.dateRange.start
        }&end_date=${this.dateRange.end}`;
      }
      this.delegateSearch(this.tabs, url);
    },
    resetDate() {
      this.dateRange = { start: "", end: "" };
      this.delegateSearch(this.tabs, this.urlBuilder(this.items[this.tabs].tabName));
    },
  },
};
</script>